import mainServices from '@/services/main'
export default {
  data () {
    return {
      allCities: [],
      allCountries: []
    }
  },
  methods: {
    getAllCities () {
      mainServices.getAllCities().then(res => {
        this.allCities = res.data || []
      })
    },
    getAllCountries () {
      mainServices.getAllContries().then(res => {
        this.allCountries = res.data.data || res.data || []
      })
    }
  },
  created () {
    this.getAllCities()
    this.getAllCountries()
  }
}
